import { Modal } from "antd";
import React, { useRef, useState } from "react";
import { BiSolidVideoPlus } from "react-icons/bi";
import { FaPlay, FaPause, FaDownload } from "react-icons/fa";
import { LuFileCheck2 } from "react-icons/lu";
import digiSteth from "../../../Assets/Images/digiStethnew.png";
import digiStethCard from "../../../Assets/Images/digistethCard.png";
import digistethLungs from "../../../Assets/Images/digistethLungs.png";

const recordings = [
  {
    id: 1,
    label: "Normal Heart Sounds (S1 & S2)",
    src: "/audios/s1s2.mp3",
  },
  {
    id: 2,
    label: "Systolic Murmur",
    src: "/audios/systolic.mp3",
  },
  {
    id: 3,
    label: "Vesicular Breath Sounds",
    src: "/audios/vesicular.mp3",
  },
  {
    id: 4,
    label: "Wheezing",
    src: "/audios/wheezing.mp3",
  },
];

const DigitalSteth = () => {
  const audioRefs = useRef([]);
  const [playingIndex, setPlayingIndex] = useState(null);
  const [progressMap, setProgressMap] = useState({});
  const [durationMap, setDurationMap] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const togglePlay = (index) => {
    const audio = audioRefs.current[index];

    // Pause all other audios
    audioRefs.current.forEach((a, i) => {
      if (i !== index && a) {
        a.pause();
      }
    });

    if (audio.paused) {
      audio.play();
      setPlayingIndex(index);
    } else {
      audio.pause();
      setPlayingIndex(null);
    }
  };

  const handleTimeUpdate = (index) => {
    const audio = audioRefs.current[index];
    setProgressMap((prev) => ({ ...prev, [index]: audio.currentTime }));
  };

  const handleLoadedMetadata = (index) => {
    const audio = audioRefs.current[index];
    setDurationMap((prev) => ({ ...prev, [index]: audio.duration }));
  };

  const handleSeek = (index, value) => {
    const audio = audioRefs.current[index];
    audio.currentTime = parseFloat(value);
    setProgressMap((prev) => ({ ...prev, [index]: parseFloat(value) }));
  };

  return (
    <div className="bg-[#F5F9FA] rounded-lg p-4 max-w-5xl mx-auto">
      <div className="flex justify-between items-center mb-4 flex-wrap gap-2">
        <div className="flex gap-2 my-2 cursor-pointer">
          <span
            onClick={showModal}
            className="flex gap-2 rounded-full px-2 bg-[#FFD9D9] justify-center items-center"
          >
            <BiSolidVideoPlus className="text-[#FF4949] w-6 h-6" />
            <span> Live Streaming</span>
          </span>
          <span
            onClick={showModal}
            className="flex gap-2 rounded-full px-2 bg-[#F5FFFF] justify-center items-center"
          >
            <LuFileCheck2 />
            <span>Saved Graphs</span>
          </span>
        </div>
        <span className="text-sm text-gray-500">12/07/2024 📅</span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-1 max-h-[200px] overflow-y-scroll">
        <img
          src={digiStethCard}
          alt="ecg"
          className="w-full h-full object-contain"
        />
        <img
          src={digistethLungs}
          alt="ecg"
          className="w-full h-full object-contain"
        />
      </div>
      {isModalOpen && (
        <div
          class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
          onClick={handleCancel}
        >
          <img src={digiSteth} alt="ecg" className="w-[80%] h-[90%]" />
        </div>
      )}
      {/* <Modal
        title="DigitalSteth"
        closable={{ "aria-label": "Custom Close Button" }}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[]}
        width={1200}
      >
      </Modal> */}
    </div>
  );
};

export default DigitalSteth;
